import {apiBaseUrl, request, requestBlob} from './apiClient.js';
const cacheBuster = `?t=${new Date().getTime()}`;

export const api = {

    userRegister(userData) {
        return request('/user/register', 'POST', userData);
    },
    userLogin(username, password, remember_me) {
        return request('/user/login', 'POST', { username, password, remember_me });
    },

    userGetProfile() {
        return request('/user/profile', 'GET');
    },
    userPutProfile(profileData) {
        return request('/user/profile', 'PUT', profileData);
    },

    userPutPassword(passwordData) {
        return request('/user/password', 'PUT', passwordData);
    },
    userPutStatus(newStatus) {
        return request('/user/status', 'PUT', { status: newStatus });
    },

    userForgetRequest(username) {
        return request('/user/forgot/request', 'POST', { username });
    },
    userForgetVerify(username, code) {
        return request('/user/forgot/verify', 'POST', { username, code });
    },
    userForgetReset(username, token, new_password) {
        return request('/user/forgot/reset', 'POST', { username, token, new_password });
    },

    userGetProfileAvatar() {
        return requestBlob(`/user/profile/avatar${cacheBuster}`);
    },
    userPostProfileAvatar(avatar) {
        return request(`/user/profile/avatar${cacheBuster}`, 'POST', { avatar });
    },
    userPostProfileAvatarEndpoint() {
        return apiBaseUrl + '/user/profile/avatar';
    },
    userDeleteProfileAvatar() {
        return request('/user/profile/avatar', 'DELETE');
    },

    userGetSessions() {
        return request('/user/sessions', 'GET');
    },
    userDeleteSessionsOthers() {
        return request('/user/sessions/others', 'DELETE');
    },
    userDeleteSessionId(sessionId) {
        return request(`/user/sessions/${sessionId}`, 'DELETE');
    },


    generalGetQuote() {
        return request('/general/quote', 'GET');
    },
    generalGetEvents() {
        return request('/general/events', 'GET');
    },


    accountingGetDetails() {
        return request('/accounting/hoofer/details', 'GET');
    },
    accountingGetLedgers(detail_id) {
        return request(`/accounting/hoofer/ledgers/${detail_id}`, 'GET');
    },
    accountingGetContacts() {
        return request('/accounting/contacts', 'GET');
    },
    accountingGetContactId(contact_id) {
        return request(`/accounting/contacts/${contact_id}`, 'GET');
    },
    accountingPostContact(contactData) {
        return request(`/accounting/contacts`, 'POST', contactData);
    },
    accountingPutContact(contact_id, contactData) {
        return request(`/accounting/contacts/${contact_id}`, 'PUT', contactData);
    },
    accountingDeleteContact(contact_id) {
        return request(`/accounting/contacts/${contact_id}`, 'DELETE');
    },
    accountingGetContactBalance(contact_id) {
        return request(`/accounting/contacts/${contact_id}/balance`, 'GET');
    },

};